export default "__VITE_ASSET__B3aMNoGL__"